// Hide "Free" price globally
function hideFree() {
  document.querySelectorAll('.free, .free-price-text').forEach(function(el) {
    el.style.setProperty('display', 'none', 'important');
  });
}

hideFree();

var observer = new MutationObserver(hideFree);
observer.observe(document.body, { childList: true, subtree: true });

// Wholesale Label Validator
(function() {
  const PICK_OPTION = 'Pick an Option';
  const ERROR_MSG = 'Please select a label type before adding to cart.';
  const WHOLESALE_COLLECTION = 'wholesale-shopping-chickenmash-farm';

  if (!window.location.pathname.includes(WHOLESALE_COLLECTION)) return;

  function isPickOption(select) {
    if (!select) return true;
    const opt = select.options[select.selectedIndex];
    if (!opt) return true;
    return opt.value.trim() === PICK_OPTION;
  }

  function setupValidator() {
    document.querySelectorAll('.ajax-submit').forEach(function(btn) {
      if (btn.dataset.wholesaleValidated === '1') return;
      btn.dataset.wholesaleValidated = '1';

      const form = btn.closest('form') || document.body;
      const select = form.querySelector('.single-option-selector[data-option="option1"]');

      let errorEl = form.querySelector('.wholesale-error-msg');
      if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.className = 'wholesale-error-msg';
        errorEl.setAttribute('role', 'alert');
        errorEl.textContent = ERROR_MSG;
        errorEl.style.cssText = 'display:none;color:#7e0909;background-color:#fff3cd;padding:12px 16px;margin-top:12px;border-radius:4px;font-size:14px;font-weight:600;border-left:4px solid #ee9b40;';
        btn.parentNode.insertBefore(errorEl, btn);
      }

      btn.addEventListener('click', function(e) {
        if (isPickOption(select)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          errorEl.style.display = 'block';
          errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } else {
          errorEl.style.display = 'none';
        }
      }, true);

      if (select) {
        select.addEventListener('change', function() {
          if (!isPickOption(select)) errorEl.style.display = 'none';
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(setupValidator, 500); });
  } else {
    setTimeout(setupValidator, 500);
  }

  new MutationObserver(function(mutations) {
    for (var m of mutations) {
      if (m.addedNodes.length) { setTimeout(setupValidator, 200); break; }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
